import { Box, Stack, Typography, type SxProps } from '@mui/material';
import type { ReactNode } from 'react';
import type { SemanticColor } from './semanticColor';
import { IconTile } from './IconTile';

interface PageHeaderProps {
  /** Title text. Accepts any ReactNode so icons / tooltips can sit beside it. */
  title: ReactNode;
  description?: string;
  actions?: ReactNode;
  /** Optional leading icon, rendered in an IconTile — most list pages have one. */
  icon?: ReactNode;
  iconColor?: SemanticColor;
  sx?: SxProps;
}

export function PageHeader({ title, description, actions, icon, iconColor = 'primary', sx }: PageHeaderProps) {
  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          {icon && <IconTile icon={icon} color={iconColor} size="md" />}
          <Box>
            <Typography variant="h5" fontWeight={700} letterSpacing="-0.01em">
              {title}
            </Typography>
            {description && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                {description}
              </Typography>
            )}
          </Box>
        </Stack>
        {actions && (
          <Stack direction="row" spacing={1}>
            {actions}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
